/**
 * Oracle JET configuration for CloudFish.
 * Loads config from public/config/oracle-jet.json so it can be overridden without rebuild.
 */

const DEFAULT_JET_CONFIG = {
  baseUrl: 'js',
  use: 'local',
  cdns: {
    jet: {
      prefix: 'https://static.oracle.com/cdn/jet/10.1.0/default/js',
      config: 'bundles-config.js',
    },
    '3rdparty': 'https://static.oracle.com/cdn/jet/10.1.0/3rdparty',
  },
};

let cachedConfig = null;

/**
 * Get Oracle JET config. Fetches from /config/oracle-jet.json if available, else returns default.
 * @returns {Promise<{ baseUrl: string, use: string, cdns: object }>}
 */
export async function getOracleJetConfig() {
  if (cachedConfig) return cachedConfig;
  try {
    const base = process.env.PUBLIC_URL || '';
    const res = await fetch(`${base}/config/oracle-jet.json`, { cache: 'default' });
    if (res.ok) {
      cachedConfig = await res.json();
      return cachedConfig;
    }
  } catch (_) {
    // use default
  }
  cachedConfig = DEFAULT_JET_CONFIG;
  return cachedConfig;
}

/**
 * Get JET CDN base URL for scripts (e.g. to load ojs or knockout from CDN).
 * @returns {Promise<string>}
 */
export async function getJetCdnPrefix() {
  const config = await getOracleJetConfig();
  const useCdn = (config.use || '').toLowerCase() === 'cdn';
  if (useCdn && config.cdns && config.cdns.jet && config.cdns.jet.prefix) {
    return config.cdns.jet.prefix.replace(/\/$/, '');
  }
  return (config.cdns && config.cdns.jet && config.cdns.jet.prefix)
    ? config.cdns.jet.prefix.replace(/\/$/, '')
    : DEFAULT_JET_CONFIG.cdns.jet.prefix.replace(/\/$/, '');
}

/**
 * Sync default config (for use when you don't need async).
 */
export const defaultOracleJetConfig = DEFAULT_JET_CONFIG;
